'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

import { CustomerInfo } from 'app/utils/authentication'

import { analytics, trackProductByLocationSearch, trackProductByManagerSearch } from './segment'
import { useAnalyticsAuth } from './useAnalyticsAuth'

type Props = {
  customerInfo: CustomerInfo
}

const Analytics = ({ customerInfo }: Props): null => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  useAnalyticsAuth(customerInfo)

  useEffect(() => {
    analytics.page()

    trackLocationAndManagerSearch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, searchParams])

  const trackLocationAndManagerSearch = () => {
    if (!pathname || (!pathname.includes('browse') && !pathname.includes('bundle'))) {
      return
    }

    const locationId = searchParams?.get('location')
    const managerId = searchParams?.get('manager')

    if (locationId) {
      trackProductByLocationSearch(locationId, pathname)
    }

    if (managerId) {
      trackProductByManagerSearch(managerId, pathname)
    }
  }

  return null
}

export default Analytics
